import { createValidationSchema, emailField, passwordField, stringField, NotFoundError, runUnsafe, } from "@for-it/domain-lib";
import { UserEntity } from "../../entities/user.js";
export const resetPassword = {
    name: "resetPassword",
    description: "Resets the password of a user using a token from a password reset request.",
    type: "command",
    payloadSchema: createValidationSchema({
        email: emailField({
            required: true,
            message: "Must be a valid email",
        }),
        password: passwordField({
            required: true,
            message: "Must be a valid password",
        }),
        token: stringField({
            required: true,
            message: "Must be a valid token",
        }),
    }),
    useCase: async ({ db, crypto }, { password, token, email }) => {
        const user = await db.findOneBy(UserEntity, { email });
        if (!user) {
            return new NotFoundError();
        }
        if (user.passwordResetToken !== token) {
            return new NotFoundError();
        }
        const hashedPassword = await runUnsafe(crypto.hashPassword(password));
        user.hashedPassword = hashedPassword;
        user.passwordResetToken = null;
        user.passwordResetTokenUpdatedAt = null;
        user.passwordResetAttemptsCount = 0;
        await db.update(UserEntity, user.id, user);
        return user;
    },
};
